var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfounit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 0C2.2386 0 0 2.2386 0 5C0 7.7613 2.2386 9.9999 5 9.9999C7.7614 9.9999 10 7.7613 10 5C10 2.2386 7.7614 0 5 0ZM4.9937 2.2577C5.1057 2.1361 5.2422 2.0743 5.3992 2.0743C5.5265 2.0743 5.6385 2.1201 5.7226 2.2068C5.8072 2.293 5.8501 2.4033 5.8501 2.5343C5.8501 2.6985 5.7927 2.8445 5.6796 2.9682C5.5634 3.0958 5.4275 3.1607 5.2761 3.1607C5.1511 3.1607 5.0404 3.1138 4.956 3.0251C4.8724 2.9382 4.8297 2.8246 4.8297 2.688C4.8297 2.5207 4.8849 2.3759 4.9937 2.2577ZM5.8266 6.9684C5.4121 7.3582 5.1162 7.6012 4.9224 7.7116C4.7156 7.83 4.5452 7.8878 4.4017 7.8878C4.2591 7.8878 4.1428 7.8403 4.0558 7.7468C3.9715 7.6564 3.9288 7.5343 3.9288 7.3843C3.9288 7.0009 4.146 6.1105 4.5931 4.6622C4.6007 4.6377 4.6066 4.6144 4.6106 4.5927C4.5939 4.5999 4.5746 4.6101 4.5522 4.624C4.5156 4.6471 4.4041 4.7346 4.0778 5.0534C4.028 5.1021 3.9501 5.1066 3.895 5.0639L3.702 4.9146C3.6712 4.8909 3.6518 4.8553 3.6484 4.8165C3.645 4.7778 3.658 4.7394 3.6841 4.7106C3.9848 4.3795 4.2655 4.1391 4.5185 3.9961C4.7833 3.8469 5.0072 3.7743 5.2027 3.7743C5.3291 3.7743 5.4312 3.8057 5.5064 3.8679C5.5882 3.9361 5.6314 4.0308 5.6314 4.1419C5.6314 4.2148 5.5968 4.4047 5.3414 5.2612C4.9766 6.485 4.8894 6.9292 4.8835 7.0829C4.9525 7.0421 5.1158 6.9261 5.4644 6.5985C5.5187 6.5471 5.6039 6.5481 5.6572 6.6001L5.8283 6.7669C5.8556 6.7935 5.8709 6.83 5.8705 6.8681C5.8701 6.9062 5.8543 6.9423 5.8266 6.9684Z",
    fill: "#C1C5CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfounit);
export default __webpack_public_path__ + "static/media/Infounit.7ad510cd19e0ce29af36b099ca7b3506.svg";
export { ForwardRef as ReactComponent };